import { useEffect, useState } from 'react';

import DeleteIcon from '@mui/icons-material/Delete';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  IconButton,
  Typography,
} from '@mui/material';
import { useFormContext } from 'react-hook-form';

import './AccordionLayout.scss';

interface AccordionLayoutProps {
  index: number;
  children: any;
  onDelete: Function;
  hasError: boolean;
  forceRerender: number;
  isDragging: boolean; // On drag and drop is moving
}
function AccordionLayout({
  index,
  children,
  onDelete,
  hasError,
  forceRerender,
  isDragging,
}: AccordionLayoutProps) {
  const [isExpanded, setIsExpanded] = useState(false);
  const { getValues } = useFormContext();

  useEffect(() => {}, [forceRerender]);

  return (
    <Accordion
      onChange={() => setIsExpanded(!isExpanded)}
      className={
        `${hasError ? 'accordion-item--error' : ''}
         ${isDragging ? 'accordion-item--dragging' : ''}`
      }
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />} className="draggable">
        <Typography>
          Rule #
          { getValues().rules[index].ruleId }
        </Typography>
        {
          isExpanded
            ? (
              <IconButton
                color="primary"
                onClick={(e) => {
                  e.stopPropagation();
                  onDelete();
                }}
                size="small"
              >
                <DeleteIcon color="primary" />
              </IconButton>
            )
            : null
        }
      </AccordionSummary>
      <AccordionDetails>
        { children }
      </AccordionDetails>
    </Accordion>
  );
}

export default AccordionLayout;
